import styled from 'styled-components'

/**
 * Styled components are used in order to style AddonGroup component. Props are passed through ThemeProvider.
 */
export const AddonGroupStyle = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
